import { defineComponent as _defineComponent } from 'vue'
import { useCountdown } from '@/lib/countdown'
import { clear, queue } from '@/lib/logging'
import { computed, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Toasts',
  props: {
    items: { type: null, required: true },
    timeout: { type: Number, required: false, default: 6000 },
    horizontal: { type: String, required: false, default: 'right' },
    vertical: { type: String, required: false, default: 'bottom' },
    color: { type: String, required: false, default: '' }
  },
  setup(__props: any) {

const props = __props as { items: typeof queue.value, timeout: number, horizontal: 'left' | 'center' | 'right', vertical: 'top' | 'bottom', color: string };



const gap = 10

const offsetX = computed(() => {
  return props.horizontal === 'left' ? gap : props.horizontal === 'center' ? 0 : -gap
})
const offsetY = computed(() => {
  return props.vertical === 'top' ? gap : -gap
})

const time = useCountdown(props.timeout, {
  onComplete: () => clear(props.items[0]?.id),
})
const progressWidth = computed(() => {
  if (props.items.length === 0 || time.remaining.value === 0) return '0%'
  return `${(time.remaining.value / props.timeout) * 100}%`
})
watch(
  () => props.items,
  (items) => (items.length ? time.start() : time.reset()),
  { immediate: true }
)

return { __sfc: true,props, gap, offsetX, offsetY, time, progressWidth, clear }
}

})